import { IMultiTransferTask } from 'api/apiPairs/models';
import { Spinner } from 'ui/Spinner/Spinner';
import { ENetwork } from 'web3';

import { TransfersSectionItem } from './TransfersSectionItem';

interface TransfersSectionProps {
  isLoading?: boolean;
  title: string;
  tasks: IMultiTransferTask[];
  tokenMeta: Map<number, { symbol: string; decimals: number }>;
  network: ENetwork;
}

export const TransfersSection = ({
  isLoading,
  title,
  tasks,
  tokenMeta,
  network,
}: TransfersSectionProps) => {
  return (
    <section className="flex flex-col gap-3">
      <div className="flex items-center justify-start gap-2 h-[24px]">
        <h4 className="text-sm uppercase tracking-wide">{title}</h4>
        {isLoading && <Spinner size="mini" />}
      </div>
      {tasks.length ? (
        <div className="flex flex-col gap-3">
          {tasks.map(task => (
            <TransfersSectionItem
              key={`${task.wallet_src}-${task.token_id}-${task.finished}-${task.amount_total}`}
              task={task}
              tokenMeta={tokenMeta}
              network={network}
            />
          ))}
        </div>
      ) : (
        <div className="text-xs text-gray-500">No tasks</div>
      )}
    </section>
  );
};
